import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 14"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M8.635.154a2 2 0 0 1 2.19.438l2.588 2.618a2 2 0 0 1-.003 2.834l-2.299 2.299a1 1 0 1 1-1.414-1.414l2.3-2.3.003-.003-.007-.007L9.404 2l-.003.003-2.33 2.33a1 1 0 0 1-1.414-1.414L7.986.589a2 2 0 0 1 .65-.435ZM4.333 5.627a1 1 0 0 1 0 1.414l-2.33 2.33L2 9.374l.003.003 2.62 2.62.003.003.003-.003 2.33-2.33a1 1 0 0 1 1.414 1.414l-2.329 2.33a2 2 0 0 1-2.837-.001L.59 10.793a2 2 0 0 1 0-2.837l2.329-2.329a1 1 0 0 1 1.414 0m4.874.58a1 1 0 0 0-1.414-1.414l-3 3a1 1 0 0 0 1.414 1.414z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Link = { render };
export {
  Link as default,
  render
};
//# sourceMappingURL=Link.svg.js.map
